import clsx from 'clsx';
import {AnimatePresence, motion} from 'framer-motion';
import type {ProductWithNodes} from '../../../types';
import ProductMedia from '../../media/ProductMedia.client';

type Props = {
  storefrontProduct: ProductWithNodes;
};

const CONTAINER = {
  hidden: {opacity: 0, y: -5},
  show: {
    opacity: 1,
    y: 0,
    transition: {
      delayChildren: 0.1,
      staggerChildren: 0.1,
      duration: 0.7,
      ease: 'easeOut',
    },
  },
};

const ITEM = {
  hidden: {opacity: 0},
  show: {opacity: 1},
};

export default function ProductGallery({storefrontProduct}: Props) {
  const media = storefrontProduct?.media?.nodes;

  if (!media?.length) {
    return null;
  }

  return (
    <div className={clsx('relative hidden md:block', 'w-full')} tabIndex={-1}>
      <AnimatePresence>
        <motion.div
          variants={CONTAINER}
          initial="hidden"
          animate="show"
          exit="hidden"
          className="ml-8 grid grid-cols-2 gap-1"
        >
          {media.map((item, index) => (
            <motion.div
              variants={ITEM}
              key={index}
              className={clsx(
                'relative col-span-1 overflow-hidden',
                '[&:nth-child(3n+1)]:col-span-2',
              )}
            >
              <ProductMedia
                className={clsx(
                  index == 0 ? 'lg:aspect-[unset] lg:h-screen' : '',
                  'aspect-[4/5] w-full select-none bg-stone-200 object-cover',
                )}
                item={item}
                index={index}
              />
              <p className="py-1 text-sm">
                {String(index + 1).padStart(2, '0')}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
